const element = document.documentElement;
const drawerClose = new Event('drawerClose');

const fireDrawerEvent = {
  open(id) {
    const drawerOpen = new CustomEvent('drawerOpen', {
      detail: id,
    });
    const event = drawerOpen;
    element.dispatchEvent(event);
  },
  close() {
    const event = drawerClose;
    element.dispatchEvent(event);
  }
};

export default fireDrawerEvent;
